import React from "react"
import {GatsbyImage} from 'gatsby-plugin-image'
import { graphql, StaticQuery } from "gatsby"
import {Row, Col, Card, CardTitle, CardBody} from "reactstrap"
import Layout from "../components/layout"
import Seo from "../components/seo"
import NewsletterSignup from "../components/newsletterSignup"
import Multiplayer from "../components/multiplayer"
import SubscriptionOptions from "../components/SubscriptionOptions"

const IndexPage = () => {
    
  return(
  <Layout pageTitle="">
    <Seo title="Home" keywords={[`complete developer podcast`, `software`]} />
        <StaticQuery query={indexQuery} render={data => {
          return (
            <Row className="mainPagePlayer">
              <Col md={{size: 5, offset: 1}}>
                <Multiplayer episodes={data.allMarkdownRemark.edges}></Multiplayer>
              </Col>
              <Col md={{size: 5, offset: 1}}>
                <GatsbyImage image={data.mainSiteImage.childImageSharp.gatsbyImageData}/>
              </Col>              
              <Col md="4">
                <Card>
                  <CardTitle>Subscription Options</CardTitle>
                  <CardBody>
                    <SubscriptionOptions></SubscriptionOptions>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                  <Card>
                    <CardTitle>Will's New Book!</CardTitle>
                    <CardBody>
                      <GatsbyImage image={data.bookImage.childImageSharp.gatsbyImageData}></GatsbyImage>
                    </CardBody>
                  </Card>
              </Col>
              <Col md="4">
                  <Card>
                    <CardTitle>Sign Up For Updates</CardTitle>
                    <CardBody>
                      <NewsletterSignup/>
                    </CardBody>
                  </Card>
              </Col>
            </Row>
          )
        }}/>    
  </Layout>
  )
}

const indexQuery = graphql`query MyQuery {
  allMarkdownRemark(
      sort: {fields: [frontmatter___date], order:DESC},
      filter: {fields: {released: {eq: true}, category: {eq: "episode"}}}
    limit: 10
    ) {
    totalCount
    edges{
      node{
        id
        frontmatter{
          title
          date(formatString: "MMM Do YYYY")
          author
          tags
          audioFile
        }
        fields {
          slug
          episodeDuration
          episodeMp3Url
        }
        excerpt
      }
    }
  }
  mainSiteImage: file(relativePath: { eq: "mainsiteimagelg.jpg" }) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
  bookImage: file(relativePath: {eq: "RemoteWork.png"}){
    childImageSharp{
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
}
`

export default IndexPage
